/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LogoUseTypeModelSearchResultModel } from '../../models/logo-use-type-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface LogoUseTypeSearchLogoUseTypePost$Params {
      body?: SearchRequestModel
}

export function logoUseTypeSearchLogoUseTypePost(http: HttpClient, rootUrl: string, params?: LogoUseTypeSearchLogoUseTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<LogoUseTypeModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, logoUseTypeSearchLogoUseTypePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<LogoUseTypeModelSearchResultModel>;
    })
  );
}

logoUseTypeSearchLogoUseTypePost.PATH = '/LogoUseType/SearchLogoUseType';
